import type WebSocket from 'ws';
import {
  beginMainBridgeDeferredDisconnect,
  evaluateDuplicateBridgeDisconnect,
  logDuplicateBridgeWarning,
  scheduleMainBridgeReconnect,
} from './reconnect/index.js';
import type { MainBridgeWsLifecycleParams } from './main-bridge-ws-lifecycle-types.js';

export function createMainBridgeCloseHandler(
  params: MainBridgeWsLifecycleParams,
  connect: () => void,
): (code: number, reason: string) => void {
  const { state, logFn, bridgeHeartbeat } = params;

  return (code: number, reason: string) => {
    bridgeHeartbeat?.stop();
    try {
      const was = state.currentWs as WebSocket | null;
      state.currentWs = null;
      if (was) was.removeAllListeners();
      const willReconnect = !state.closedByUser;
      if (willReconnect) {
        const duplicateResult = evaluateDuplicateBridgeDisconnect(
          state.duplicateBridgeFlap,
          Date.now(),
          code,
          reason,
        );
        logDuplicateBridgeWarning(logFn, duplicateResult);
      }
      beginMainBridgeDeferredDisconnect(state, code, reason, logFn, willReconnect);
      if (willReconnect) {
        state.lastReconnectCloseMeta = { code, reason };
        try {
          scheduleMainBridgeReconnect(state, connect, logFn, { code, reason });
        } catch {
          /* schedule failure should not escape */
        }
      }
    } catch {
      if (!state.closedByUser) {
        try {
          scheduleMainBridgeReconnect(state, connect, logFn);
        } catch {
          /* ignore */
        }
      }
    }
  };
}
